import { render, staticRenderFns } from "./calendarUser.vue?vue&type=template&id=54749ab4"
import script from "./calendarUser.vue?vue&type=script&lang=js"
export * from "./calendarUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports